import { z } from "zod";

/**
 * Execution node metadata - stored in WorkflowExecutionNode.metadata Json field.
 */
export const ExecutionNodeMetadataSchema = z.record(z.string(), z.unknown());

/**
 * The loop-specific keys the loop executor writes into
 * `WorkflowExecutionNode.metadata`, and the only ones the loop UI reads.
 *
 * A subset of {@link ExecutionNodeMetadataSchema} — unknown keys are stripped
 * rather than rejected, so a node carrying metadata from another concern still
 * parses. Parse with `safeParse` at the read boundary: the column is nullable
 * and holds whatever was written before this schema existed.
 */
export const LoopNodeMetadataSchema = z.object({
  /** Ids of the per-iteration WorkflowExecutions, in iteration order. */
  loopExecutionsOrderedIds: z.array(z.string()).optional(),
  /**
   * Total iterations the loop will run, known upfront for for-each loops. Absent
   * for do-while, where the total is not known until the loop stops.
   */
  loopTotalIterations: z.number().optional()
});

export type LoopNodeMetadata = z.infer<typeof LoopNodeMetadataSchema>;
